import { Layers, TileLayer, VectorLayer } from "views/OLMap/Layers";
import { mapboxbase, googlebase } from "views/OLMap/Source";
import React, { useEffect } from "react";
import "views/OLMap/ol-map.css";
import MapContext from "views/OLMap/Map/MapContext";
import PropTypes from "prop-types";
import { fromLonLat } from "ol/proj";
import * as ol from "ol";
import { defaults as defaultControls } from "ol/control/defaults";
import { useSelector } from "react-redux";
import { geojsons } from "assets/geojson";
import { MousePosition } from "ol/control";
import { createStringXY } from "ol/coordinate";
import { getFeaturesSourceFromJson } from "utils/mapProcess";
import { OSM } from "ol/source";
import GeoJSON from "ol/format/GeoJSON";
import { bingAerialLabels } from "../OLMap/Source";
import GridCard from "../Cards/GridCard";
import MKBox from "../../components/MKBox";

const GridCardMapNewJob = ({ map, mapRef, setMap, className }) => {
  const dataSelection = useSelector((state) => state.dataSelection);
  const viewOptions = {
    zoom: 4,
    center: fromLonLat([83, 28]),
    // extent: [6010000, 1600000, 12245143, 5160979],
  };
  const mousePositionControl = new MousePosition({
    coordinateFormat: createStringXY(4),
    projection: "EPSG:4326",
    className: "custom-mouse-position",
  });

  const vectorlayer =
    dataSelection.buildin !== "" && !dataSelection.draw ? (
      <VectorLayer
        key={dataSelection.buildin}
        visible
        className={dataSelection.buildin}
        source={getFeaturesSourceFromJson(dataSelection.buildin, geojsons)}
        zIndex={1}
      />
    ) : null;

  useEffect(() => {
    if (dataSelection.buildin !== "" && map !== null) {
      const FeatureJson = geojsons.filter((a) => a.name === dataSelection.buildin)[0].json;
      const geom = new GeoJSON().readFeatures(FeatureJson)[0].getGeometry();
      map.getView().fit(geom, {
        padding: [50, 50, 50, 50],
      });
    }
  }, [dataSelection.buildin]);

  const basemapStatus = useSelector((state) => state.dataLayers);
  const baseLayers = (
    <>
      {basemapStatus.filter((basemap) => basemap.name === "mapbox")[0].selected ? (
        <TileLayer source={mapboxbase()} className="mapbox" baseLayer zIndex={0} visible />
      ) : null}
      {basemapStatus.filter((basemap) => basemap.name === "google")[0].selected ? (
        <TileLayer source={googlebase()} className="google" baseLayer zIndex={0} visible />
      ) : null}
      {/* {basemapStatus.filter((basemap) => basemap.name === "bing-Aerial")[0].selected ? ( */}
      {/*   <TileLayer source={bingAerial()} className="bingAerial" baseLayer zIndex={0} visible /> */}
      {/* ) : null} */}
      {basemapStatus.filter((basemap) => basemap.name === "bing-Aerial-labels")[0].selected ? (
        <TileLayer
          source={bingAerialLabels()}
          className="bingAerialLables"
          baseLayer
          zIndex={0}
          visible
        />
      ) : null}{" "}
      {basemapStatus.filter((basemap) => basemap.name === "openStreetMap")[0].selected ? (
        <TileLayer source={new OSM()} className="osm" baseLayer zIndex={0} visible />
      ) : null}
    </>
  );

  // on component mount
  useEffect(() => {
    const options = {
      view: new ol.View(viewOptions),
      layers: [],
      controls: defaultControls().extend([mousePositionControl]),
      overlays: [],
    };
    const mapObject = new ol.Map(options);
    mapObject.setTarget(mapRef.current);
    setMap(mapObject);
    return () => mapObject.setTarget(undefined);
  }, []);

  return (
    <GridCard title="Map">
      <MKBox sx={{ px: 1, pb: 1 }}>
        <MapContext.Provider value={{ map }}>
          <div ref={mapRef} className={className}>
            <Layers>
              {baseLayers}
              {vectorlayer}
            </Layers>
          </div>
        </MapContext.Provider>
      </MKBox>
    </GridCard>
  );
};

GridCardMapNewJob.defaultProps = {
  map: null,
  setMap: null,
  mapRef: null,
  className: null,
};

GridCardMapNewJob.propTypes = {
  map: PropTypes.oneOfType([PropTypes.any]),
  setMap: PropTypes.oneOfType([PropTypes.any]),
  mapRef: PropTypes.oneOfType([PropTypes.any]),
  className: PropTypes.string,
};

export default GridCardMapNewJob;
